//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
export default {
  name: 'FIBStaffButton',
  components: {
    FibStaffMember: require('@/pages/staff/Member').default
  },
  data: function data() {
    return {
      showLogInModal: false
    };
  },
  computed: {
    enableStaffPinCodes: get('config/config@branch.enableStaffPinCodes'),
    isApp: get('config/isApp')
  },
  methods: {
    returnToStaff: function returnToStaff() {
      if (!this.enableStaffPinCodes) {
        this.$router.push('/staff');
      } else {
        this.showLogInModal = true;
      }
    },
    redirectToStaff: function redirectToStaff(login) {
      if (login.result) {
        this.$router.push('/staff');
      }
    },
    goToSettings: function goToSettings() {
      this.$store.commit('settings/showSettingsSection', true);
      this.$store.commit('settings/loggedInMember', null);
      this.$router.push('/staff');
    }
  }
};